import { Molecule } from 'AppReact';
import styled, { css } from 'styled-components';
import { Progress } from './atoms';

const template = styled.div`
  ${({ displayState }) => css`
    width: 100%;
    background-color: #F3F5F5;
    height:  ${displayState?.height ?? '13px'};
    border-radius: 60px;
    position: relative;
    display: flex;
    justify-content: flex-start;
  `}
`;

export default Molecule({
  template,
  atoms: [
    {
      component: Progress,
      name: 'Progress2',
      displayValue: ({ }) => '',
      displayState: ({ total, completed, started }) => ({ progress: ((completed + started) / total) * 100, color: '#FFC700' })
    },
    {
      component: Progress,
      name: 'Progress',
      displayValue: ({ }) => '',
      displayState: ({ total, completed }) => ({ progress: (completed / total) * 100, color: '#1DBD6B' })
    },
  ],
})